import { render, staticRenderFns } from "./SerieOptions.vue?vue&type=template&id=5cf384ab&scoped=true&"
import script from "./SerieOptions.vue?vue&type=script&lang=js&"
export * from "./SerieOptions.vue?vue&type=script&lang=js&"
import style0 from "./SerieOptions.vue?vue&type=style&index=0&id=5cf384ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf384ab",
  null
  
)

export default component.exports